export default {
  10001: '請輸入使用者名稱或信箱',
  10002: '郵箱輸入有誤',
  10003: '使用者名稱輸入有誤',
  10004: '密碼輸入有誤',
  10005: '使用者狀態異常',
  10006: '使用者名稱已存在',
  10007: '郵箱已存在',
  10008: '使用者狀態有誤',
  10009: '未找到對應用戶',
  10010: '智能交易產品不正確',
  10011: '用戶餘額不足，請儲值或釋放保證金後購買',
  10012: '未找到對應天數',
  10013: '投資金額有誤',
  10014: '量化交割產品不正確',
  10015: '目前未在可交易時間',
  10016: '購買金額不正確',
  10017: '未找到對應期限',
  10018: '取得系統參數失敗',
  10019: '該用戶當前認證狀態不正確',
  10020: '藏品狀態不正確',
  10021: '未填寫接收地址',
  10022: '用戶未實名認證',
  10023: '貸款期限設定有誤',
  10024: '貸款金額超出範圍',
  10025: '已購買相同產品，請勿重複購買',
  10026: '請選擇提款方式',
  10027: '借款金額不能為空',
  10028: '借款期限不能為空',
  10029: '借款金額必須大於0',
  10030: '借款期限設定不存在',
  10031: '借款金額低於最低限額',
  10032: '借款金額超過最高限額',
  10033: '借款紀錄ID不能為空',
  10034: '借款紀錄不存在',
  10035: '沒有操作該借款紀錄的權限',
  10036: '借款狀態不允許還款',
  10037: '帳戶餘額不足',
  10094: 'VIP等級不足，需要{level}及以上等級',
  10095: '投資金額超過最高限額',
  10108: '美股目前不在交易時段（美東週一至週五 9:30-16:00），請稍後再試',
  10109: '外匯/貴金屬目前不在交易時段（美東週日17:00至週五17:00），請稍後再試',
  10110: '交易數量無效，請輸入大於0的數量',
  20001: '提交審核成功',
  20002: '儲值添加成功，已提交審核',
  20003: '提現添加成功，已提交審核',
  20004: '購買成功',
  20005: '修改成功',
  20024: '已購買相同產品，請勿重複購買',
  20094: '超出提款限額，每人每天限提一次',
  20095: '提款正在審核中，請勿重複操作',
  20096: '購買失敗（限制2次）',
  20097: '購買失敗（限制3次）',
  20098: '每位用戶的購買訂單數量限制為: 3',
  20099: '每位用戶的購買訂單數量限制為: 2',
  20100: '每位用戶的購買訂單數量限制為: 1',
  20102: '您的帳號已被凍結，暫無法進行交易與提現。如有疑問請聯絡客服。',
  20103: '登入狀態已失效，請重新登入',
  20104: '用戶未登入，請先登入',
  Invite: {
    CopyLink: '複製鏈接',
    FillInAccount: '填寫在線表格並開設交易賬戶',
    Fund: '資金',
    FundYourPrefer: '通過您喜歡的任何資金方式為您的賬戶充值',
    InviteFriends: '邀請朋友',
    InviteYourFriends: '邀請您的朋友',
    Register: '註冊',
    StartTradingPlatform: '開始使用我們屢獲殊榮的交易平台進行交易',
    Trade: '交易',
    WhenYourRewards: '邀請您的親朋好友加入我們，一起收穫豐厚的回報，踏上致富之路！',
  },
  Market: {
    CreateAPlanToTrade: '創建交易計劃',
    ETF: 'ETF',
    ExpectedReturn: '預期利潤',
    LastPrice: '最新價格',
    Lots: '手',
    OpenPrice: '開倉價格',
    OrderAgain: '再次下單',
    OrderNumber: '訂單號',
    Price: '價格',
    Prices: '價格',
    Sizes: '手...',
    SpotPrice: '價格',
    StopLossPrices: '止損價格...',
    TakeProfitPrices: '止盈價格...',
    WantMoreStableEarning: '想要更穩定的收益',
    WhatIsSmartTrading: '什麼是智能交易',
    available: '可用',
    buy: '買多',
    buyLong: '買/買多',
    buyLongBtn: '買多',
    chart: '圖表',
    checkoutSuccess: '結算成功',
    close: '收盤價',
    confirm: '確認',
    contracts: '合約',
    create: '創建',
    cypto: '加密貨幣',
    day: '天',
    down: '跌',
    estimation: '預期利潤',
    forex: '外匯',
    free: '交易費',
    frees: '交易費',
    futures: '大宗',
    high: '最高價',
    hour: '小時',
    investment: '投資金額...',
    leverage: '槓桿',
    limit: '限價',
    low: '最低價',
    market: '市價',
    min: '分鐘',
    mon: '月',
    name: '名稱',
    notOpen: '功能暫未開放',
    open: '開盤價',
    options: '量化交割',
    optionsTime: '量化交割時間',
    orderConfirm: '訂單確認',
    requiredMargin: '所需保證金',
    return: '收益',
    sell: '賣空',
    sellShort: '賣/賣空',
    sellShortBtn: '賣空',
    stocks: '股票',
    stopLoss: '止損',
    stopLossPrice: '止損價格',
    takeProfit: '止盈',
    takeProfitPrice: '止盈價格',
    time: '時間',
    up: '漲',
    volume: '成交量',
    watchlist: '收藏',
    week: '週',
  },
  SmartTrading: {
    InterInvestmentAmount: '投資金額...',
    SelectATimeframe: '選擇一個時間週期',
    create: '創建',
    createAPlan: '創建計劃',
    dailyYield: '日收益',
    days: '天',
    investment: '金額',
    investmentRange: '資金限額',
    product: '產品',
    smrtTrading: '智能交易',
    timeframe: '時間週期',
  },
  about: {
    aboutUs: '關於我們',
  },
  aboutUs: {
    about: '關於我們',
    subtitle1: '公司簡介',
    subtitle2: '合作夥伴',
    title: '關於{title}',
  },
  account: {
    BTCAmount: '金額',
    LOTS: '手',
    LastDigits: '最後6位數字',
    Lots: '手',
    PaymentAmount: '支付金額',
    PleaseUploadSubmission: '請上傳加密貨幣支付的截圖，並在提交後等待驗證',
    Preview: '預覽',
    SelectImage: '選擇圖片',
    Supports: '支持格式：JPG、JPEG2000、PNG',
    TransactionHash: '交易哈希',
    UploadProof: '上傳證明',
    UploadYourScreenshot: '上傳您的轉賬截圖',
    accountVerification: '賬戶驗證',
    address: '地址',
    allOrders: '全部訂單',
    amount: '金額',
    approved: '批准日期',
    balance: '餘額',
    buy: '買多',
    cancel: '取消',
    changeLanguage: '更改語言',
    changePassword: '更改密碼',
    close: '平倉',
    closePrice: '平倉價格',
    closeTime: '平倉時間',
    closed: '已關閉',
    contactUs: '聯繫我們',
    copyAddress: '複製地址',
    copySuccess: '複製成功',
    cycle: '週期',
    dailyRor: '日收益率',
    demo: '演示賬戶',
    deposit: '存款',
    depositWithdraw: '存款和提款',
    down: '跌',
    downloadPDF: '下載貸款協議',
    earlyExist: '終止交易',
    earlyExit: '終止交易',
    earlyExitTip: '如果提前終止交易，系統將自動扣除本金的{num}作為違約金，您的總收入將被扣除',
    expandMore: '展開更多',
    expirationTime: '到期時間',
    failed: '失敗',
    freeMargin: '佔用保證金',
    futures: '合約',
    helpCenter: '常見問題',
    inviteFriends: '邀請好友',
    lastPrice: '最新價格',
    lever: '槓桿',
    liquidatedDamages: '違約金',
    loan: '貸款',
    logOut: '退出登入',
    logoutConfirm: '確定要退出登入嗎？',
    margin: '預期利潤',
    myAccount: '我的賬戶',
    notification: '通知',
    notifications: '通知',
    okay: '好的',
    open: '開倉價格',
    openPrice: '開倉價格',
    openTime: '開倉時間',
    options: '量化交割',
    optionsOrder: '量化交割訂單',
    order: '訂單',
    pips: '點數',
    profit: '利潤',
    putAway: '收起',
    receiveAddress: '接收地址',
    recreatePlan: '繼續創建計劃',
    refund: '退款',
    refundTip: '資金將退還至您的現金賬戶，請查收。',
    repayNow: '立即還款',
    repayment: '還款',
    repaymentAmount: '還款金額',
    repaymentDate: '還款日期',
    repeatOrder: '繼續開倉',
    reviewed: '待審核',
    runTime: '運行時間',
    save: '保存',
    sell: '賣空',
    settings: '設置',
    smart: '智能交易',
    startTime: '開始時間',
    staticincome: '錢包收益',
    status: '狀態',
    success: '成功',
    time: '時間',
    todayEarnings: '今日收益',
    todayProfit: '今日利潤',
    totalInterest: '總利息',
    totalProfit: '總利潤',
    totalRepayment: '還款總額',
    totalRevenue: '總收益',
    transFees: '交易費用',
    transRecord: '交易記錄',
    transaction: '交易',
    type: '類型',
    up: '漲',
    withdraw: '取款',
    withdrawNow: '立即取款',
  },
  amount: '金額',
  bangZhuZhongXin: '幫助中心',
  biaoDian: '標點',
  board: {
    content: '本軟件以最佳技術專業滿足您的所有需求',
    continue: '繼續',
    skip: '跳過',
    title: '最佳交易平台',
  },
  bread: {
    introduction: '簡介',
  },
  chaKan: '查看',
  chongZhi: '儲值',
  chongZhiJinexiaoYuZuiDiChongZhiJinE: '儲值金額小於最低儲值金額',
  chongZhiPingZheng: '儲值憑證',
  chongZhiShiJian: '儲值時間',
  chongZhiShuoMing: '儲值說明：',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    '儲值說明：USDT最低儲值金額為120，BTC最低儲值金額為0.015，ETH最低儲值金額為0.2',
  close: '關閉',
  common: {
    loadMore: '載入更多',
  },
  'customerService.error': '客服系統異常，請稍後再試。',
  'customerService.close': '關閉',
  'customerService.connected': '已連線',
  'customerService.imageAlt': '客服圖片',
  'customerService.imagePreview': '圖片預覽',
  'customerService.imageTooLarge': '圖片不能超過 5MB',
  'customerService.imageTypeUnsupported': '僅支援 PNG、JPEG 或 WebP 圖片',
  'customerService.imageUnavailable': '圖片已失效',
  'customerService.loadFailed': '在線客服暫時無法載入，請稍後再試。',
  'customerService.loading': '載入中…',
  'customerService.loginRequired': '請先登錄後再聯繫客服',
  'customerService.openImage': '查看原圖',
  'customerService.placeholder': '輸入消息，Enter 發送',
  'customerService.send': '發送',
  'customerService.sendImage': '發送圖片',
  'customerService.reconnecting': '正在重新連線',
  'customerService.title': '在線客服',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    '大多數網站都會採取措施保護使用者的個人資訊，例如使用加密技術來保護密碼。',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    '大多數網站都允許用戶更改他們的個人訊息，例如更改電子郵件地址或密碼。\n但是，某些資訊可能無法更改，例如使用者名稱。',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    '貸款後{num}天內無須支付利息，{num}天後需支付利息。',
  daiShenHe: '待審核',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    '但是，如果您使用的網站或應用程式存在安全漏洞，您的個人資訊可能會被洩露。',
  dangQiLiRun: '當期利潤',
  dangQianLiXi: '當前利息',
  daoQiHuanXiHuanBen: '到期還息還本',
  daoQiShiJian: '到期時間',
  dengLuChengGong: '登入成功',
  di: '低',
  dianHuaHaoMa: '電話號碼：',
  dieJiaLiShuai: '疊加利率:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: '高',
  gouMai: '購買',
  gouMaiChengGong: '購買成功',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei: '國際貨幣帳戶聯絡線上支援服務進行匹配',
  home: {
    Application: '應用',
    AvailableOnThe: 'Available on the',
    CreditCard: '加密',
    CreditCardInfo: '通過使用加密貨幣進行存款，可以獲得額外的安全層，並確保快速交易處理。',
    CryptocurrenciesListed: '上市加密貨幣',
    GetStarted: '開始',
    NewFeaturesInOnline: '在線新功能',
    NewFeaturesInOnlineInfo: '了解這個完整平台的精彩功能',
    RegisteredUsers: '註冊用戶',
    allChains: '全部鏈',
    announcementClose: '關閉公告',
    announcementLabel: '公告',
    announcementView: '查看詳情',
    announcementAmount: '借出金額',
    announcementAnnualRate: '年化收益率',
    announcementBelowMinimum: '低於 {amount} USDT',
    announcementCompoundInterest: '複利',
    announcementCurrentConfig: '目前配置',
    announcementEarningMode: '計息方式',
    announcementRateNotice: '收益按後台目前檔位規則計算；實際金額以用戶資產頁和結算記錄為準。',
    announcementRatesLoading: '正在讀取目前收益檔位…',
    announcementSettlement: '每日結算時點',
    announcementSimpleInterest: '單利',
    announcementYieldEyebrow: '收益說明',
    announcementYieldIntro:
      '借出金額越高，適用的年化收益率越高；低於首檔金額仍可參與，但不產生利息。',
    announcementYieldTitle: '目前收益明細',
    appLicationInfo: '摒棄傳統規則的移動銀行，為您提供精確的財務管理工具。',
    billion: 'B',
    billionInfo: '平均24小時交易量',
    button1Title: '最低交易費用',
    button1Title1: '在一個地方交易所有資產',
    button1Title2: '外匯、加密貨幣、股票、ETF、期貨',
    button2Title: '低利率和更高額度',
    button2Title1: '投資借款',
    button2Title2: '無需抵押品，輕鬆借款，享受財富增值機會！',
    button3Title: '簡單穩定',
    button3Title1: '智能交易',
    button3Title2: '一鍵創建您的盈利計劃',
    button4Title: '幫助世界各地的兒童',
    button4Title1: 'NFT慈善',
    button4Title2: '購買NFT藝術品以支持聯合國兒童基金會',
    closeFeatured: '關閉推薦',
    colApy: 'APY',
    colAsset: '資產',
    colChain: '所屬鏈',
    colTotalDeposits: '總存款',
    depositAction: 'Deposit',
    depositSubtitle: '借貸池提供流動性以賺取利息',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: '篩選資產...',
    homeTitle: '在最佳平台上購買、交易和持有350多種加密貨幣。',
    loading: '載入中...',
    million: 'M',
    noMore: '沒有更多了',
    noPools: '暫無借貸池數據',
    noticeInfo: '錢包可以將BTC兌換為USD',
    noticeInfo1: '用模擬賬戶操作',
    onlineSupport: '在線客服',
    periodDays: '{count}天',
    sortApy: '排序：APY',
    sortTotalDeposits: '排序：總存款',
  },
  huanKuanZhong: '還款中',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    '歡迎使用我們屢獲殊榮的金融交易平台，與全球投資者一起探索未來的金融世界！',
  jiXiShiJian: '計息時間',
  jiXuTouZi: '繼續投資',
  jiangTuPianTuoFangDaoCiChuHuo: '將圖片拖放到此處, 或',
  jieZhiShiJian: '截止時間',
  jiuMiMa: '舊密碼',
  juJueYuanYin: '拒絕原因',
  kai: '開',
  lendingAssets: {
    addAsset: '新增授權幣種',
    authorizedBalance: '授權資產餘額',
    availableAmount: '可提現金額',
    dailyOrders: '每日結算訂單',
    dailyProfit: '每日收益',
    estimated24hEarnings: '預計24小時收益',
    estimated24hHint: '基於當前授權餘額與檔位利率估算的明日收益',
    joinPool: '加入借貸池',
    loadMore: '載入更多',
    needAuth: '加入借貸池後即可查看資產餘額與收益',
    needLogin: '請先登入後查看資產',
    noOrders: '暫無結算訂單',
    pageDesc: '查看授權資產餘額、借貸池收益與每日結算訂單',
    poolEarnings: '借貸池收益',
    todayEarnings: '今日收益',
    totalEarnings: '累計收益',
    withdraw: '提現',
    withdrawRecords: '提現記錄',
    withdrawnAmount: '已提現金額',
    walletBalances: '錢包資產餘額',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      '<p><strong>文檔版本：</strong>V3.28 &nbsp;|&nbsp; <strong>發布日期：</strong>2022 年 &nbsp;|&nbsp; <strong>文檔性質：</strong>產品白皮書與安全評估摘要</p>\n\n<h2>一、摘要</h2>\n<p>本借貸池（Lending Pool）是基於去中心化金融（DeFi）貨幣市場協議構建的鏈上流動性存貸服務模組。系統通過開源智能合約與程序化利率模型，將用戶的數字資產接入成熟的鏈上借貸市場，實現<strong>存款生息、抵押借款、流動性共享</strong>等核心功能。</p>\n<p>本模組不依賴人工干預進行日常資金調度，利率、容量、利用率等關鍵指標均由鏈上市場實時決定，並通過多源數據聚合與定時同步機制向用戶透明展示。本文檔旨在說明產品架構、運行機制、安全設計、風險披露及合規評估結論，供用戶與合作夥伴查閱。</p>\n\n<h2>二、行業背景與產品定位</h2>\n<p>傳統金融借貸依賴中心化機構進行信用評估與資金撮合，存在門檻高、透明度低、跨境結算成本高等問題。DeFi 借貸協議通過智能合約自動匹配供需雙方，以超額抵押與清算機制保障系統償付能力，已成為 Web3 基礎設施的重要組成部分。</p>\n<p>本借貸池模組的定位為：</p>\n<ul>\n  <li><strong>鏈上貨幣市場入口：</strong>聚合多鏈、多協議借貸池數據，為用戶提供統一的存貸信息視圖；</li>\n  <li><strong>程序化收益分配：</strong>依據授權資產餘額與市場 APY，按固定週期自動結算收益；</li>\n  <li><strong>透明可驗證：</strong>池子 TVL、APY、利用率、LTV 等指標可溯源至公開鏈上數據；</li>\n  <li><strong>非託管原則：</strong>用戶資產授權與鏈上交互由用戶錢包發起，平台不持有用戶私鑰。</li>\n</ul>\n\n<h2>三、系統架構</h2>\n<h3>3.1 架構概覽</h3>\n<p>系統採用分層架構設計，主要包含以下組件：</p>\n<ul>\n  <li><strong>用戶交互層：</strong>Web / 移動端界面，支持錢包連接、資產授權、池子瀏覽、收益查詢；</li>\n  <li><strong>業務服務層：</strong>用戶鑑權、授權狀態管理、收益訂單生成與查詢、多語言內容展示；</li>\n  <li><strong>數據聚合層：</strong>對接 DeFi 數據聚合 API 及協議 GraphQL 接口，定時同步借貸池指標；</li>\n  <li><strong>鏈上協議層：</strong>基於經審計的開源借貸協議智能合約，執行實際的存借邏輯。</li>\n</ul>\n\n<h3>3.2 核心數據指標</h3>\n<table>\n  <thead>\n    <tr><th>指標</th><th>說明</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL（總鎖倉價值）</td><td>池內資產以美元計價的總量，反映市場深度</td></tr>\n    <tr><td>Supply APY（存款年化）</td><td>由基礎利率與協議獎勵疊加構成，隨利用率動態浮動</td></tr>\n    <tr><td>Borrow APY（借款年化）</td><td>借款人需支付的年化成本，與資金利用率正相關</td></tr>\n    <tr><td>Utilization Rate（利用率）</td><td>已借出資金占可借資金的比例，影響利率曲線</td></tr>\n    <tr><td>Max LTV（最高貸款價值比）</td><td>抵押品可支撐的最大借款比例，超額部分觸發清算</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>單資產供給與借款上限，用於控制集中度風險</td></tr>\n    <tr><td>Available Liquidity</td><td>當前可即時借出的流動性規模</td></tr>\n  </tbody>\n</table>\n\n<h3>3.3 數據同步機制</h3>\n<p>借貸池市場數據通過定時任務從公開數據源拉取，寫入本地緩存與歷史快照，用於前端展示、歷史曲線及運營監控。每次同步記錄時間戳，確保數據可追溯。</p>\n\n<h2>四、用戶流程與收益機制</h2>\n<h3>4.1 參與流程</h3>\n<ol>\n  <li><strong>連接錢包：</strong>用戶通過 Web3 錢包完成身份綁定；</li>\n  <li><strong>資產授權：</strong>對 USDT、USDC 等支持資產執行鏈上 Approve 授權；</li>\n  <li><strong>加入借貸池：</strong>系統根據授權狀態將用戶納入對應池子的收益計算隊列；</li>\n  <li><strong>收益結算：</strong>按固定週期（每日）依據授權餘額與市場利率生成結算訂單；</li>\n  <li><strong>資產查詢：</strong>用戶可在「個人資產」頁查看授權餘額、累計收益及歷史結算明細。</li>\n</ol>\n\n<h3>4.2 利率模型</h3>\n<p>存款利率（Supply APY）由基礎 APY 與獎勵 APY 兩部分組成，實際到賬收益受授權餘額、市場 APY 波動、結算週期及鏈上 Gas 等因素影響。<strong>歷史 APY 不代表未來收益。</strong></p>\n\n<h3>4.3 費用說明</h3>\n<h4>DeFi 賺幣如何收費？</h4>\n<p>鏈上交易需支付 gas 費用，以完成與智能合約的交互操作，包括認購和領取收益。對於部分資產，DeFi 借貸池與金庫管理方將根據您實際獲得的利潤收取一定比例的業績費，本金不受影響。</p>\n\n<h2>五、安全設計</h2>\n<ul>\n  <li>底層借貸協議採用經多家安全機構審計的開源合約，核心邏輯鏈上執行；</li>\n  <li>非託管架構，平台不存儲用戶私鑰或助記詞；</li>\n  <li>僅請求業務所需的 Token Approve 權限，用戶可隨時在錢包中撤銷；</li>\n  <li>接口鑑權、HTTPS 傳輸、後台 RBAC 權限隔離與操作審計。</li>\n</ul>\n\n<h2>六、安全評估摘要</h2>\n<table>\n  <thead>\n    <tr><th>評估項</th><th>結論</th><th>說明</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>智能合約依賴</td><td><strong>通過</strong></td><td>採用經公開審計的 DeFi 協議合約</td></tr>\n    <tr><td>非託管與密鑰管理</td><td><strong>通過</strong></td><td>無私鑰存儲，授權由用戶錢包本地簽名</td></tr>\n    <tr><td>API 與鑑權安全</td><td><strong>通過</strong></td><td>接口鑑權與 HTTPS 已落實</td></tr>\n    <tr><td>數據同步與一致性</td><td><strong>通過</strong></td><td>定時同步 + 快照機制，數據可溯源</td></tr>\n    <tr><td>收益結算邏輯</td><td><strong>通過</strong></td><td>週期結算規則明確，訂單可追溯</td></tr>\n  </tbody>\n</table>\n<p><strong>總體評估結論：</strong>在現有架構與運維規範下，核心安全控制措施有效。用戶仍須自行評估 DeFi 協議層風險，並妥善保管錢包私鑰。</p>\n\n<h2>七、風險披露</h2>\n<ul>\n  <li><strong>智能合約風險：</strong>儘管經審計，合約仍可能存在未被發現的漏洞；</li>\n  <li><strong>市場風險：</strong>APY 隨利用率與治理提案波動，可能出現大幅變化；</li>\n  <li><strong>清算風險：</strong>抵押品價格劇烈下跌可能觸發清算；</li>\n  <li><strong>穩定幣脫錨風險：</strong>USDT、USDC 等在極端條件下可能偏離錨定價格；</li>\n  <li><strong>監管政策風險：</strong>各國對 DeFi 的監管政策仍在演進。</li>\n</ul>\n<p><strong>本模組不提供投資建議，也不保證任何固定收益。</strong></p>\n\n<h2>八、術語表</h2>\n<ul>\n  <li><strong>APY：</strong>年化收益率；</li>\n  <li><strong>TVL：</strong>總鎖倉價值；</li>\n  <li><strong>LTV：</strong>貸款價值比；</li>\n  <li><strong>Approve：</strong>ERC-20 代幣授權；</li>\n  <li><strong>清算（Liquidation）：</strong>抵押品不足時自動出售抵押品以償還債務。</li>\n</ul>\n\n<p>— 本文檔僅供信息參考，不構成法律、財務或投資建議。鏈上數據以區塊瀏覽器及協議官方接口為準。</p>',
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: '請先登入後再進行實名認證',
    needVerifyHint: '請先完成實名認證後再加入借貸池',
    pageDesc: '完成實名認證後即可加入借貸池，享受存貸服務',
    pendingHint: '您的實名認證正在審核中，請耐心等待',
  },
  lendingMenu: {
    assets: '資產',
    chooseDepositAsset: '選擇存入資產',
    chooseDepositHint: '將資產存入借貸池以獲取收益，並支持後續借款',
    copyUid: '複製 UID',
    customerService: '在線客服',
    depositAssetAction: '存入 {symbol}',
    earnings: '盈利方式',
    empty: '暫無內容',
    explore: '探索',
    footerDesc:
      '依託開源智能合約搭建的新一代鏈上貨幣市場，以程式化規則代替人工管控，為全球Web3用戶提供安全透明的流動性存貸服務。',
    getStarted: '立即加入',
    home: '首頁',
    identityVerification: '實名認證',
    intro: '簡介',
    language: '語言',
    noAssetPool: '暫未找到該資產的借貸池',
    rulesSecurity: '規則與安全',
    security: '安全性',
    theme: '外觀',
    uid: 'UID',
    whitepaper: '平台白皮書',
    yieldLadder: '收益階梯',
  },
  lendingTheme: {
    auto: '跟隨系統',
    dark: '深色',
    light: '淺色',
    title: '外觀',
  },
  lendingYieldLadder: {
    balance: '單筆借出本金（USDT）',
    compoundInterest: '複利',
    earningMode: '收益顯示方式：{mode}',
    empty: '暫無檔位配置',
    loading: '正在載入檔位利率…',
    noteFixed: '每日按該檔位固定日化利率結算',
    noteRange: '每日按該檔位區間上限結算',
    notes: '說明',
    rate: '日化收益率區間',
    settlementHours: '配置結算時點：{hours}',
    simpleInterest: '單利',
  },
  liangCiMiMaBuYiZhi: '兩次密碼不一致',
  loan: {
    Browse: '瀏覽',
    address: '地址：',
    birthdate: '出生日期：',
    borrow: '借款',
    borrowNow: '立即藉款',
    borrowPlaceholder: '我想藉...',
    browse: '瀏覽',
    checkIn: '提交完成',
    confirm: '確認',
    continue: '繼續',
    country: '國家：',
    dailyRate: '日利率',
    days: '天',
    document: '證件：',
    done: '完成！',
    driverLicense: '駕照',
    dropHere: '將圖片拖放到此處',
    ensure: '確定',
    female: '女',
    firstName: '名字：',
    idCard: '身份證',
    inHand: '進行拍照',
    lastName: '姓氏：',
    launchCamera: '啟動相機',
    loanAgreement: '貸款協議',
    loanAmount: '貸款金額',
    loanAmountRangeError: '貸款金額必須在 {min} - {max} USD 範圍內',
    loanAmountTooHigh: '貸款金額不能超過 {max} USD',
    loanAmountTooLow: '貸款金額不能低於 {min} USD',
    loanDetail: '貸款詳情',
    loanTerm: '貸款期限',
    male: '男',
    notVerifyBtn: '開始驗證',
    notVerifyTip: '驗證您的身份，獲得更多貸款額度！',
    or: '或',
    passport: '護照',
    pendingReview: '審核中',
    phone: '電話號碼：',
    phonePlaceholder: '輸入您的電話號碼...',
    reSign: '重新簽署',
    resubmit: '重新提交',
    sex: '女性/男性：',
    sign: '簽署',
    signTip: '請確認並簽署',
    signed: '已簽署',
    startVerfication: '開始驗證',
    submit: '提交',
    supports: '支持：JPG, JPEG2000, PNG',
    takePhoto: '拍照',
    term: '貸款期限（天）',
    tipIdCardBack: '將身份證背面置於框內',
    tipIdCardFront: '將身份證正面置於框內',
    tipNotPass:
      '很抱歉，您的KYC申請未通過驗證過程。請重新提交正確的申請材料以完成KYC驗證。如果您有任何疑問或需要幫助，請隨時聯繫我們的客戶服務團隊。',
    tipTakePhoto: '請手持您的',
    tipVerifiedSuccess: '恭喜！您的KYC申請已通過驗證，您現在可以享受更高級別的服務。',
    tipWaitForResult:
      '感謝您提交KYC認證資料。我們的團隊將在48小時內對您的資料進行審核，請耐心等待！',
    title: '貸款',
    totalAmount: '總利息金額',
    verifiedSuccessfully: '驗證成功',
    verifiedUnsuccessfully: '驗證失敗',
    verifyBtn: '驗證成功',
    verifyTip: '獲得即時資金來保障您的投資！',
  },
  login: {
    btnContinueFacebook: '繼續使用Facebook',
    btnContinueGoogle: '繼續使用谷歌',
    btnLogin: '登錄',
    btnLoginFacebook: '使用Facebook登錄',
    btnLoginGoogle: '使用谷歌登錄',
    btnNext: '下一步',
    btnRecovery: '找回',
    btnRecoveryPsd: '找回密碼',
    btnRegister: '註冊',
    btnRegisterFacebook: '使用Facebook註冊',
    btnRegisterGoogle: '使用谷歌註冊',
    btnSend: '發送',
    btnSignup: '使用郵箱註冊',
    email: '郵箱',
    emailPlaceholder: '請輸入郵箱，如 name@example.com',
    emailTips: '該郵箱已被註冊',
    hasAccount: '已經有帳戶？',
    hasNotAccount: '還沒有帳戶？',
    inputCode: '請輸入驗證碼',
    inputEmail: '請輸入郵箱',
    inputPassword: '請輸入密碼',
    inputPhone: '請輸入郵箱',
    inputUsernameOrEmail: '請輸入用戶名或郵箱',
    labelEmail: '郵箱：',
    labelEmailCode: '驗證碼:',
    labelPsd: '密碼：',
    labelPsdNew: '新密碼：',
    labelPsdRepeat: '確認密碼：',
    labelUsername: '用戶名：',
    labelUsernameOrEmail: '用戶名或郵箱：',
    phone: '郵箱：',
    phoneTips: '該郵箱已被註冊',
    starLogin: '讓我們從登錄開始！',
    starRegist: '讓我們從註冊開始！',
    starReset: '通過郵箱找回密碼！',
    tipRegisterContent:
      '完成您的註冊並打開通往令人興奮的投資機會世界的大門，為財務成功和增長鋪平道路！',
    tipRegisterTitle: '註冊並開始您的繁榮投資之旅！',
    useEmailRegister: '使用郵箱註冊',
    usePhoneRegister: '使用手機號註冊',
    username: '使用者名稱',
    usernameOptional: '用戶名（可選，不填則與郵箱相同）',
    usernameTips: '該用戶名已存在！',
    welcome: '歡迎來到',
  },
  navBottom: {
    bottomCompany: '公司',
    bottomCompanyItem1: '關於我們',
    bottomCompanyItem2: '牌照監管',
    bottomCompanyItem3: '常見問題',
    bottomCompanyItem4: '在線支持',
    bottomOther: '聲明',
    bottomOtherItem1: '法律信息',
    bottomOtherItem2: '免責聲明',
    bottomOtherItem3: '風險提示',
    bottomOtherItem4: 'Cookie政策',
    bottomOtherItem5: '關於廣告',
    bottomPolicy: '政策',
    bottomPolicyItem1: '條款條件',
    bottomPolicyItem2: '隱私政策',
    bottomProduct: '產品',
    bottomProductItem1: '市場列表',
    bottomProductItem2: '投資借貸',
    bottomProductItem3: '公益NFT',
    bottomProductItem4: '智能交易',
  },
  navTab: {
    btnLogin: '登錄',
    btnSignup: '註冊',
    language: '語言',
    languageTips: '選擇語言和地區',
    tabMenu1: '首頁',
    tabMenu2: '市場',
    tabMenu3: '智能交易',
    tabMenu4: '貸款',
    tabMenu5: '理財',
    tabMenu6: 'NFTs',
    tabMenu7: '帳戶',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: '您輸入的停損價格不合理',
  ninShuRuDeZhiYingJiaGeBuHeLi: '您輸入的止盈價格不合理',
  notifications: {
    deposit: {
      content:
        '尊敬的用戶，我們已收到您\u0024{amount}美元的存款，並已成功將\u0024{amount}添加到您的賬戶餘額中。',
      title: '存款通知',
    },
    kyc: {
      content: '尊敬的用戶，恭喜您通過了KYC驗證。您現已完成KYC流程，可以享受更高級別的服務。',
      title: 'KYC驗證通過',
    },
    loan: {
      content:
        '尊敬的客戶，恭喜您，您的貸款申請已獲批准，金額為\u0024{amount}美元。我們已審核並通過了您的申請，貸款金額已存入您的賬戶。請登錄您的賬戶查看詳細信息。',
      title: '貸款已批准',
    },
    repayment: {
      content: '尊敬的用戶，我們已成功收到您\u0024{amount}美元的還款。感謝您一直以來的支持。',
      title: '還款成功',
    },
    withdraw: {
      content: '尊敬的用戶，您申請的\u0024{amount}美元提現已成功處理。請留意相關信息並及時查收。',
      failed: {
        content:
          '尊敬的用戶，您的\u0024{amount}元提現請求失敗。請仔細檢查提現信息，並及時聯繫在線客服。',
        title: '提現通知',
      },
      title: '提現通知',
    },
  },
  ntfs: {
    Address: '地址',
    AllMoneyCharities: 'NFTs銷售所得的全部款項將捐贈給聯合國兒童基金會慈善機構',
    BuyNFT: '購買NFT藝術品，幫助世界各地的兒童！',
    BuyNow: '立即購買',
    Chain: '所屬鏈',
    Confirm: '確認',
    Creator: '創作者',
    CumulativeDonation: '累計捐款',
    CurrentBid: '當前出價',
    Markets: '市場',
    MyNFTs: '我的NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'NFTs詳情',
    PlaceABid: '競拍',
    RemainingTime: '剩餘時間',
    Successful: '成功',
    ThanksDonation: '感謝您的捐贈',
    Thisaddress: '該物品將發送至您的錢包地址',
    Verified: '已驗證',
    andUNICEF: '捐款將捐贈給聯合國兒童基金會',
    charity: '慈善',
  },
  null: '未知錯誤',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: '請切換為真實帳戶操作',
  qingShangChuanPingZheng: '請上傳憑證',
  qingShuRuDiZhi: '請輸入地址',
  qingShuRuShouJiHao: '請輸入信​​箱',
  qingShuRuTouZiJinE: '請輸入投資金額',
  qingShuRuYanZhengMa: '請輸入驗證碼',
  qingShuRuZhengQueDeJinE: '請輸入正確的金額',
  qingShuRuZhengQueDeYouXiang: '請輸入正確的信箱',
  qingShuRuZhiSunJiaGe: '請輸入停損價格',
  qingShuRuZhiYingJiaGe: '請輸入止盈價格',
  qingTianXieWanZhengXinXi: '請填寫完整資訊',
  qingZaiCiShuRuMiMa: '請再次輸入密碼',
  queRenMiMa: '確認密碼',
  repaySuccess: '還款成功',
  return: '結算時間',
  ri: '日',
  riLiShuai: '日利率:',
  search: {
    SearchHere: '搜索',
  },
  shangChuanShiBaiQingZhongShi: '上傳失敗，請重試',
  shenHeBuTongGuo: '審核不通過',
  shou: '收',
  shouJiHao: '信箱',
  shouXuFeiShiJiDaoZhangJinE: '手續費/實際到帳金額',
  shouYiZhong: '收益中',
  shouYiZhuangTai: '收益狀態',
  shuRuNinDeDianHuaHaoMa: '輸入您的電話號碼...',
  souSuo: '搜尋...',
  staticIncome: '錢包收益',
  tiJiaoChengGong: '提交成功',
  tiJiaoChongZhiPingZheng: '提交儲值憑證',
  tiKuanFangShi: '提款方式',
  tiXian: '提現',
  tiXianDiZhi: '提現地址',
  tiXianShiJian: '提現時間',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    '提現需要 {rate}% 的手續費，需要網路節點確認後才能入帳請不要將加密貨幣轉給陌生人',
  toast: {
    UnreasonablePriceProfitLoss: '止盈止損價格設定不合理',
    buyNumbers: '請輸入購買數量',
    copyError: '複製失敗！',
    copySuccess: '複製成功！',
    email: '請輸入您的郵箱',
    inputAll: '數據輸入不完整',
    logOut: '已登出',
    noData: '沒有更多數據',
    notAddress: '請輸入錢包地址',
    notAmount: '請輸入金額',
    notEmail: '郵箱格式不正確',
    notImage: '圖片格式不正確',
    notLoanAmount: '請輸入貸款金額',
    notSigned: '未簽名',
    notSmartAmount: '請輸入理財金額',
    notSupportMedia: '不支持獲取用戶媒體',
    notVerify: '請先完成KYC認證',
    notWithdrawAmount: '請輸入取款金額',
    nothingfound: '暫時沒有找到內容！',
    password: '請輸入密碼',
    passwordNotSame: '密碼輸入不一致',
    passwordRepeat: '請確認您的密碼',
    uploadImage: '請上傳所需圖片',
    userName: '請輸入用戶名',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    '通常，需要您的郵箱、使用者名稱、密碼等基本訊息，有時還需要個人資訊和聯絡資訊。',
  touZiShiJian: '投資時間',
  touZiZhouQi: '投資週期',
  tuPianDaXiaoBuNengChaoGuo_2mb: '圖片大小不能超過 2MB!',
  tuPianDaXiaoBuNengChaoGuo_5m: '圖片大小不能超過50MB!',
  uploadfailed: 'uploadFailed',
  usdtZuiDiChongZhiJinewei_120: '{name}最低儲值金額為{limit}',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    '外匯自動交易量化是一種利用電腦程式和演算法自動執行交易策略的方法。\n此方法使用歷史資料、技術指標、統計模型和其他分析工具來識別交易訊號，並在執行交易時自動執行這些訊號。\n外匯自動交易量化可以幫助交易者消除情緒影響，減少錯誤交易，提高交易效率和一致性。\n但是，自動外匯交易量化也存在一些潛在的風險和限制。\n例如，自動交易程序可能無法適應市場變化，交易程序和演算法的品質和有效性在很大程度上取決於歷史資料的可靠性和有效性。\n此外，自動交易還可能存在技術風險，如電腦故障、網路中斷等，因此，在使用外匯自動交易量化前，投資人需要仔細評估自己的交易目標、風險承受能力和技術能力，選擇可靠的交易平台\n。\n交易平台和自動交易程序。\n最重要的是，投資者應始終保持謹慎並採取適當的風險管理措施來保護他們的投資。',
  wallet: {
    activate: '啟動',
    authFailed: '認證失敗',
    authSuccess: '認證成功',
    authorizationFailed: '失敗',
    authorizationSuccess: '成功',
    authorized: '已授權',
    connectFailed: '錢包連接失敗',
    connectWallet: '連接錢包',
    connecting: '連接中...',
    justCanWallet: '本網站只允許來自分散式應用（Dapp）的訪問',
    networkNotSupported: '當前網絡不受支持，請切換到支持的網絡',
    noWalletDetected: '未檢測到錢包，請安裝 MetaMask 或 TronLink',
    pleaseConnectWallet: '請連接錢包',
    status: '錢包狀態',
    testnetDisabled: '測試網絡已禁用，請使用主網絡',
    transactionCancelled: '交易已取消',
    unauthorized: '未授權',
    userCancelled: '用戶已取消操作',
  },
  walletAllowanceInsufficient: '當前授權額度不足，需要重新授權',
  walletAllowanceQueryFailed: '查詢當前授權失敗',
  walletAllowanceSufficient: '當前授權額度已足夠，無需重新授權',
  walletAlreadyApproved: '已經授權，無需重新授權',
  walletApproveResult: '授權成功',
  walletApproveSuccess: '新授權交易成功',
  walletConfigEmpty: '回應為空',
  walletConfigError: '初始化錢包配置失敗',
  walletConfigFailed: '獲取錢包配置失敗',
  walletConfigLoadComplete: '配置載入完成',
  walletConfigLoaded: '錢包配置載入成功',
  walletConfigLoading: '開始執行代幣授權',
  walletConfigNotLoaded: '未載入',
  walletConfigStatus: '當前配置狀態',
  walletConnecting: '正在獲取錢包配置...',
  walletConnectingTo: '正在連接',
  walletContractCallFailed: '合約調用預檢失敗，請檢查合約地址和參數',
  walletContractFailed: '合約執行失敗，請檢查交易參數',
  walletContractInfoFailed: '合約基本信息查詢失敗，可能不是標準ERC20合約',
  walletContractInfoNormal: '合約基本信息正常',
  walletContractNotSupported: '代幣合約不支持此操作',
  walletContractPaused: '代幣合約已暫停或有其他限制',
  walletContractRejectAuth: '代幣合約拒絕了授權操作，請檢查合約是否支持標準ERC20授權',
  walletContractReverted: '合約執行被回滾，可能的原因',
  walletContractSpecialRules: '合約有特殊的授權規則',
  walletCurrentAllowance: '當前授權額度',
  walletDetecting: '自動檢測到錢包',
  walletEthConnectFailed: '以太坊錢包連接失敗',
  walletEthConnecting: '開始連接以太坊錢包...',
  walletGasEstimate: '預估Gas用量',
  walletGasEstimateFailed: 'Gas估算失敗，交易可能會失敗',
  walletGetTokenContract: '獲取代幣合約地址',
  walletInsufficientBalance: '帳戶餘額不足，請確保有足夠的ETH/TRX支付手續費',
  walletInsufficientGas: '交易費用不足，請調整Gas設定後重試',
  walletNetworkTimeout: '網路連接超時，請檢查網路後重試',
  walletNoTokenWarning: '用戶沒有此代幣，但仍可以進行授權',
  walletResetAllowance: '嘗試先重置授權為0...',
  walletResetAllowanceFailed: '重置授權失敗，繼續嘗試直接授權',
  walletResetAllowanceSuccess: '授權重置成功',
  walletSmartContractFailed: '獲取智能合約地址失敗',
  walletTokenApproveAmount: '授權數量',
  walletTokenApproveTo: '授權給',
  walletTokenApproving: '授權代幣',
  walletTokenBalanceQueryFailed: '查詢代幣餘額失敗',
  walletTransactionFailed: '交易失敗，請稍後重試',
  walletUserEthBalance: '用戶ETH餘額',
  walletUserRejected: '用戶取消了交易授權',
  walletUserTokenBalance: '用戶代幣餘額',
  walletUsingSmartContract: '使用智能合約地址作為授權目標',
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan: '網路超時,請去訂單清單查看該訂單',
  weiKaiQiZhiNengJiaoYi: '未開啟智能交易',
  weiRenZheng: '未認證',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: '為什麼我需要註冊一個帳戶？',
  weiTongGuo: '未通過',
  woDeZhuCeXinXiHuiBeiBaoMiMa: '我的註冊資料會被保密嗎？',
  woKeYiGengGaiWoDeZhuCeXinXiMa: '我可以更改我的註冊資訊嗎？',
  woKeYiZhuCeDuoGeZhangHuMa: '我可以註冊多個帳戶嗎？',
  xiaCiShouYiShiJian: '下次收益時間',
  xiaDanChengGong: '下單成功',
  xinGongNengShangXian: '新功能上線！',
  xinMiMa: '新密碼',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: '演示帳號不能使用該功能',
  yanShiZhangHuBuNengChuangJianZhiNengJiaoYi: '交易失敗：示範帳戶不能創建自動交易策略',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi: '示範帳戶不能使用智能交易',
  yanShiZhangHuYiJinYong: '演示帳戶已停用',
  yiDaoQi: '已到期',
  yiFenRun: '已分潤',
  yiFenRunTianShu: '已分潤天數',
  yiHuanKuan: '已還款',
  yiJuJue: '已拒絕',
  yiQieHuanWeiXuNiZhangHu: '已切換為虛擬帳戶',
  yiQieHuanWeiZhenShiZhangHu: '已切換為真實帳戶',
  yiRenZheng: '已認證',
  yiWanCheng: '已完成',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    '有些網站可能允許使用者註冊多個帳戶，但大多數網站只允許每個使用者註冊一個帳戶。\n如果您嘗試註冊多個帳戶，您的帳戶可能會被禁止或刪除。',
  zhangFu: '漲幅',
  zhenFu: '振幅',
  zhuCeChengGong: '註冊成功',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    '註冊帳戶可讓您更方便地使用網站或應用程式的功能，並可以保護您的個人資訊。',
  zhuCeZhangHuXuYaoShiMoXinXi: '註冊帳戶需要什麼資訊？',
  zongLiXi: '總利息',
  zuiDiJia: '最底價',
}
